import React from 'react';
import { useContext, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRepeat } from '@fortawesome/free-solid-svg-icons'
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import QuizApi from '../QuizApi';
import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';

export default function QuizAdminStartBtn() {

  const ctx = useContext(quizInstanceAdminStatusContext);
	const [starting, setStarting] = useState(false);
	const startQuiz = useCallback(() => {

		const fn = async () => 
		{
			if (!starting)
			{
				setStarting(true);
				await QuizApi.quizInstanceStart(ctx.quizInfo.id);
				setStarting(false);
			}
		};
		
		fn();

	}, [ctx, starting]);

  return (
    <Button type="submit" variant="light" onClick={startQuiz}>
      {
        starting 
          ? <Spinner className="mr-2" size="sm" animation="border" /> 
          :<FontAwesomeIcon icon={faRepeat} className="mr-2" />
      }
      Starta om tiden
    </Button>
  );
};